var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vc-button",class:[
    _vm.type && 'vc-button-type--' + _vm.type,
    _vm.size && 'vc-button-size--' + _vm.size,
    {
      'vc-button--plain': _vm.plain,
      'vc-button--round': _vm.round,
      'vc-button--block': _vm.block,
      'is-loading': _vm.loading
    }
  ],attrs:{"disabled":_vm.disabled,"type":_vm.nativeType},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('span',{staticClass:"vc-button-icon"},[_c('svg',{staticClass:"loading-icon loading-wipe",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}},[_c('g',[_c('circle',{staticClass:"loading-icon-bg-path",attrs:{"cx":"25","cy":"25","r":"20"}}),_c('circle',{staticClass:"loading-icon-active-path",attrs:{"cx":"25","cy":"25","r":"20"}})])])]):_vm._e(),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }